import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { AssetFinanceUrl } from "../../../../config";
import Form from "./form";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import Joyride from "react-joyride";
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = AssetFinanceUrl.uri;

const tourSteps = [
  {
    target: ".dynamic-table-header",
    content: "Manage vehicle makes, origin countries, display order, and active status.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find car makes by name, code, or country.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Car Make.",
    placement: "right",
  },
];

const CarMakesTable = () => {
  const [runTour, setRunTour] = useState(false);

  const handleToggle = async (row, field, currentValue, label, refetch) => {
    const confirm = await Swal.fire({
      title: `${currentValue ? "Deactivate" : "Activate"} ${label}?`,
      text: `Are you sure you want to ${currentValue ? "disable" : "enable"} "${label}" for "${row.MakeName}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;

    const response = await executeAnyMutation(
      "updateCarMake",
      {
        id: row.Id,
        code: row.Code,
        makeName: row.MakeName,
        companyId: row.CompanyId,
        [field]: !currentValue,
      },
      "carMake",
      false,
      base_url
    );

    if (response?.results) {
      await Swal.fire("Done!", `${label} has been ${!currentValue ? "enabled" : "disabled"}.`, "success");
      if (refetch) refetch();
    } else {
      await Swal.fire("Error!", "Could not update the car make. Please try again.", "error");
    }
  };

  const actions = {
    entity: localStorage.getItem("SelectedTabLabel") || "Car Makes",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    toggleActive: {
      key: "TOGGLE_ACTIVE",
      button_name: (row) => (row?.IsActive ? "Deactivate" : "Activate"),
      Show_Button: true,
      permission: "EditPermission",
      onClick: (row, refetch) => handleToggle(row, "isActive", row?.IsActive, "Active Status", refetch),
    },
    dataObject: {
      ignoreFields: ["CreatedAt", "CreatedBy", "UpdatedAt", "UpdatedBy", "CompanyId"],
      objectName: "allCarMakes",
      parameters: "",
    },
    isSubRight: true,
    showStatus: true,
    showMore: {
      search: false,
      min: 0,
      max: 0
    }
  };

  return (
    <Box m="20px">
      <Joyride
        steps={tourSteps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      <DynamicTableForJson
        title="Car Makes Management"
        subtitle="Manage Vehicle Makes, Origin Countries & Display Settings"
        FormComponent={Form}
        actions={actions}
        base_url={base_url}
        tourSteps={tourSteps}
      />
    </Box>
  );
};

export default CarMakesTable;
